import { IMonster } from './monsters'
import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { machines } from '../machines/machines-sidecar'
import { machinesDoor } from '../machines/machinesDoor-sidecar'
import { machinesAirlock2 } from '../machines/machinesAirlock2-sidecar'
import { monsters } from './monsters-sidecar'
import { monsterSelector } from '../ui/monsterSelector-sidecar'

export const updateMovement = (obj: IMonster) => {
  // Check for movement
  let moveDelayMax = calcMoveSpeed(obj)

  if (obj.path.length > 0) {
    let p = obj.path.shift()

    let doDelay = obj.moveDelay > 0
    let doWait = false

    if (p) {
      let ctx = scene.getContext()

      let door = machines.findAtSpot(p.x, p.y, (c) => c.data.type === 'door')
      if (door) {
        if (!door.isOpen) {
          machinesDoor.open(door, true)
        }
        if (machinesDoor.isInTransition(door)) {
          doWait = true
        }
      }

      let airlock2 = machines.findPartAtSpot(
        p.x,
        p.y,
        (c) => c.data.type === 'airlock2',
      )
      if (airlock2) {
        if (
          airlock2.data.name === 'bottom-right' ||
          airlock2.data.name === 'top-right'
        ) {
          if (airlock2.parent.isOpen) {
            machinesAirlock2.open(airlock2.parent, false)
            doWait = true
          }
        }

        if (
          airlock2.data.name === 'bottom-left' ||
          airlock2.data.name === 'top-left'
        ) {
          if (!airlock2.parent.isOpen) {
            machinesAirlock2.open(airlock2.parent, true)
            doWait = true
          }
          // Transition into or out of ship
        }

        if (machinesAirlock2.isInTransition(airlock2.parent)) {
          doWait = true
        }
      }

      if (doWait || doDelay) {
        if (!doWait) {
          monsters.playIdleAnimTowards(obj, p.x, p.y)
          obj.moveDelay -= common.getUpdateDeltaScaled()

          // lerp
          monsters.lerpToTile(
            obj,
            ctx.mapShip,
            p.x,
            p.y,
            1 - obj.moveDelay / moveDelayMax,
          )
        }
        obj.path.unshift(p)

        // Lerp
      } else {
        monsters.moveToTile(obj, ctx.mapShip, p.x, p.y)
        monsterSelector.updateHighlight(obj)
        obj.moveDelay = moveDelayMax
      }
    }
  }
}

export function calcMoveSpeed(obj: IMonster) {
  let adjustedMovementSpeed =
    (obj.currentMoveSpeed || obj.data.moveSpeed) * (obj.statEnergy / 100 + 0.33)
  if (obj.isInSuit) {
    adjustedMovementSpeed *= 1.25
  }
  return adjustedMovementSpeed
}
